import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=b89feb1c"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"
import style0 from "./DateComponent.vue?vue&type=style&index=0&id=b89feb1c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports